<template>
  <div class="home">
    <div class="home_wrapper">
      <div class="home_background-container">
        <h1>
          <span>Passionate</span>
          <span>Analytical</span>
          <span>Tech-Savvy</span>
          <span>Flexible</span>
          <span>Fast-Learner</span>
          <span>Adaptable</span>
          <span>Listener</span>
          <span>Problem-Solver</span>
          <span>Open-Minded</span>
          <span>Communicator</span>
          <span>Positive</span>
          <span>Creative</span>
          <span>Enthusiastic</span>
          <span>Work-Ethic</span>
          <span>Collaborative</span>
          <span>Empathic</span>
          <span>Approachable</span>
          <span>Logical</span>
          <span>Helpful</span>
          <span>Accountable</span>
          <span>Creativity</span>
          <span>Time-Management</span>
          <span>Experienced</span>
          <span>Dedicated</span>
          <span>Organized</span>
          <span>Willingness-To-Grow</span>
          <span>Perseverance</span>
          <span>Consistency</span>
          <span>Focused</span>
          <span>Troubleshooter</span>
          <span>Visual-Thinker</span>
          <span>Efficient</span>
          <span>Optimistic</span>
          <span>Multitasking</span>
          <span>Decision-Maker</span>
          <span>Friendly</span>
          <span>Team-Player</span>
          <span>Persistent</span>
          <span>Trustworthy</span>
          <span>Respectful</span>
          <span>Insight</span>
          <span>Patient</span>
          <span>Responsible</span>
          <span>Goal-Setter</span>
          <span>Leader</span>
          <span>Helpful</span>
          <span>Motivated</span>
          <span>Driven</span>
          <span>Hard-Working</span>
          <span>Talented</span>
          <span>Flexible</span>
          <span>Work-Ethic</span>
          <span>Collaborative</span>
          <span>Empathic</span>
          <span>Approachable</span>
          <span>Helpful</span>
          <span>Accountability</span>
          <span>Creativity</span>
          <span>Time-Management</span>
          <span>Experienced</span>
          <span>Dedicated</span>
          <span>Creative</span>
          <span>Enthusiastic</span>
          <span>Work-Ethic</span>
          <span>Innovative</span>
          <span>Detail-Oriented</span>
          <span>Reliable</span>
          <span>Strategic</span>
          <span>Resourceful</span>
          <span>Agile</span>
          <span>Skilled</span>
          <span>Thorough</span>
          <span>Methodical</span>
          <span>Precise</span>
          <span>Knowledgeable</span>
          <span>Resilient</span>
          <span>Proactive</span>
          <span>Dependable</span>
          <span>Humble</span>
          <span>Thoughtful</span>
          <span>Honest</span>
          <span>Passionate</span>
          <span>Analytical</span>
          <span>Tech-Savvy</span>
          <span>Flexible</span>
          <span>Fast-Learner</span>
          <span>Adaptable</span>
          <span>Listener</span>
          <span>Problem-Solver</span>
          <span>Open-Minded</span>
          <span>Communicator</span>
          <span>Positive</span>
          <span>Creative</span>
          <span>Enthusiastic</span>
          <span>Work-Ethic</span>
          <span>Collaborative</span>
          <span>Empathic</span>
          <span>Approachable</span>
          <span>Logical</span>
          <span>Helpful</span>
          <span>Accountable</span>
          <span>Creativity</span>
          <span>Time-Management</span>
          <span>Experienced</span>
          <span>Dedicated</span>
          <span>Organized</span>
          <span>Willingness-To-Grow</span>
          <span>Perseverance</span>
          <span>Consistency</span>
          <span>Focused</span>
          <span>Troubleshooter</span>
          <span>Visual-Thinker</span>
          <span>Efficient</span>
          <span>Optimistic</span>
          <span>Multitasking</span>
          <span>Decision-Maker</span>
          <span>Friendly</span>
          <span>Team-Player</span>
          <span>Persistent</span>
          <span>Trustworthy</span>
          <span>Respectful</span>
          <span>Insight</span>
          <span>Patient</span>
          <span>Responsible</span>
          <span>Goal-Setter</span>
          <span>Leader</span>
          <span>Helpful</span>
          <span>Motivated</span>
          <span>Driven</span>
          <span>Hard-Working</span>
          <span>Talented</span>
          <span>Flexible</span>
          <span>Work-Ethic</span>
          <span>Collaborative</span>
          <span>Empathic</span>
          <span>Approachable</span>
          <span>Helpful</span>
          <span>Accountability</span>
          <span>Creativity</span>
          <span>Time-Management</span>
          <span>Experienced</span>
          <span>Dedicated</span>
          <span>Creative</span>
          <span>Enthusiastic</span>
          <span>Work-Ethic</span>
          <span>Innovative</span>
          <span>Detail-Oriented</span>
          <span>Reliable</span>
          <span>Strategic</span>
          <span>Resourceful</span>
          <span>Agile</span>
          <span>Skilled</span>
          <span>Thorough</span>
          <span>Methodical</span>
          <span>Precise</span>
          <span>Knowledgeable</span>
          <span>Resilient</span>
          <span>Proactive</span>
          <span>Dependable</span>
          <span>Humble</span>
          <span>Thoughtful</span>
          <span>Honest</span>
          <span>Passionate</span>
          <span>Analytical</span>
          <span>Tech-Savvy</span>
          <span>Flexible</span>
          <span>Fast-Learner</span>
          <span>Adaptable</span>
          <span>Listener</span>
          <span>Problem-Solver</span>
          <span>Open-Minded</span>
          <span>Communicator</span>
          <span>Positive</span>
          <span>Creative</span>
          <span>Enthusiastic</span>
          <span>Work-Ethic</span>
          <span>Collaborative</span>
          <span>Empathic</span>
          <span>Approachable</span>
          <span>Logical</span>
          <span>Helpful</span>
          <span>Accountable</span>
          <span>Creativity</span>
          <span>Time-Management</span>
          <span>Experienced</span>
          <span>Dedicated</span>
          <span>Organized</span>
          <span>Willingness-To-Grow</span>
          <span>Perseverance</span>
          <span>Consistency</span>
          <span>Focused</span>
          <span>Troubleshooter</span>
          <span>Visual-Thinker</span>
          <span>Efficient</span>
          <span>Optimistic</span>
          <span>Multitasking</span>
          <span>Decision-Maker</span>
          <span>Friendly</span>
          <span>Team-Player</span>
          <span>Persistent</span>
          <span>Trustworthy</span>
          <span>Respectful</span>
          <span>Insight</span>
          <span>Patient</span>
          <span>Responsible</span>
          <span>Goal-Setter</span>
          <span>Leader</span>
          <span>Helpful</span>
          <span>Motivated</span>
          <span>Driven</span>
          <span>Hard-Working</span>
          <span>Talented</span>
          <span>Flexible</span>
          <span>Work-Ethic</span>
          <span>Collaborative</span>
          <span>Empathic</span>
          <span>Approachable</span>
          <span>Helpful</span>
          <span>Accountability</span>
          <span>Creativity</span>
          <span>Time-Management</span>
          <span>Experienced</span>
          <span>Dedicated</span>
          <span>Creative</span>
          <span>Enthusiastic</span>
          <span>Work-Ethic</span>
          <span>Innovative</span>
          <span>Detail-Oriented</span>
          <span>Reliable</span>
          <span>Strategic</span>
          <span>Resourceful</span>
          <span>Agile</span>
          <span>Skilled</span>
          <span>Thorough</span>
          <span>Methodical</span>
          <span>Precise</span>
          <span>Knowledgeable</span>
          <span>Resilient</span>
          <span>Proactive</span>
          <span>Dependable</span>
          <span>Humble</span>
          <span>Thoughtful</span>
          <span>Honest</span>
        </h1>
      </div>
    </div>
    <div class="typing-container">
      <vue-writer 
        :array="['Hello there!', 'I hope you\'re doing well today.', 'My name is Bryce Palmer, I am a Software Engineer. Welcome to my website. Please take a look around & feel free to reach out.']"
        :iterations="1"
        :typeSpeed="50"
        :eraseSpeed="40"
        :delay="1500" />
    </div>
    <div class="contact-container">
      <h3>MEVN / MERN / MEAN</h3>
      <div>
        <button class="contact-me" role="button" @click="changeNav('Contact')">CONTACT ME</button>
      </div>
    </div>
  </div>
</template>

<script>
import { VueWriter } from 'vue-writer';
export default {
  components: {
    VueWriter
  },
  name: 'Home',
  props: {
  },
  data() {
    return {
      selectedNav: 'Home'
    };
  },
  methods: {
    changeNav(loc) {
      this.selectedNav = loc;
      this.$emit('navChange', loc);
    }
  },
}
</script>

<style scoped>
  /* Container/Background */
  .home {
    height: 100vh;
    position: relative;
    overflow: hidden;
  }
  .typing-container {
    position: absolute;
    pointer-events: none;
    top: 40%;
    left: 5%;
    max-width: 750px;
    z-index: 5;
  }
  .contact-container {
    position: relative;
    left: 5%;
    top: 75%;
    max-width: 200px;
    h3 {
      font-weight: 400;
      font-size: 19px;
      color: #7a7a7a;
      text-shadow: 1px 1px 4px #111;
    }
  }
  .home_background-container {
    position: absolute;
    white-space: normal;
    width: 100%;
    overflow: hidden;
    left: 0;
    h1 {
      font-size: 2.8rem;
      font-weight: 700;
      color: #4d4d4e;
      font-family: Open Sans, sans-serif;
      text-transform: uppercase;
      text-shadow: -1px -1px 0 rgba(77, 77, 78, .1568627450980392), 
        1px -1px 0 rgba(77, 77, 78, .1568627450980392), 
        -1px 1px 0 rgba(77, 77, 78, .1568627450980392), 
        1px 1px 0 rgba(77, 77, 78, .1568627450980392);
      span {
        transition: all .6s ease-in-out;
        color: #1d1d1d;
        user-select: none;
        -webkit-user-select: none;
        letter-spacing: .2em;
        word-break: break-all;
      }
      span:hover {
        cursor: default;
        color: #00eeff;
      }
    }
    h1 {
      display: block;
      margin-block-start: 0.25em;
      margin-block-end: 0.67em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      font-weight: bold;
      unicode-bidi: isolate;
    }
  }
  .home_wrapper {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
  }

  /* Button CSS */
  .contact-me {
    --b: 3px;   /* border thickness */
    --s: .3em; /* size of the corner */
    --color: #ff00ee;
    --color2: #00eeff;
    
    margin-left: .5em;
    margin-top: 1em;
    padding: calc(.4em + var(--s)) calc(.8em + var(--s));
    color: var(--color);
    --_p: var(--s);
    background:
      conic-gradient(from 90deg at var(--b) var(--b),#0000 90deg,var(--color2) 0)
      var(--_p) var(--_p)/calc(100% - var(--b) - 2*var(--_p)) calc(100% - var(--b) - 2*var(--_p));
    transition: .3s linear, color 0s, background-color 0s;
    outline: var(--b) solid #ff00ee;
    outline-offset: .5em;
    font-size: 20px;
    font-weight: 600;
    border: 0;

    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    cursor: pointer;
  }

  .contact-me:hover,
  .contact-me:focus-visible{
    --_p: 0px;
    outline-color: var(--color2);
    outline-offset: .05em;
  }

  .contact-me:active {
    background: var(--color2);
    color: #fff;
  }

  /* typewriter */
  .is-typed {
    font-size: 3.5rem;
    color: #fff;
    font-weight: 600;    
    font-family: Open Sans, sans-serif;
    text-shadow: 2px 2px 4px #000;
    :global(span.cursor) {
      display: inline-block;
      width: 5px;
      animation: blink 1.5s 15;
    }
  }
  @keyframes blink {
    49% {
      background-color: white;
    }
    50% {
      background-color: transparent;
    }
    99% {
      background-color: transparent;
    }
  }
  @media (max-device-width: 660px) {
    .is-typed {
      font-size: 1.9rem;
    }
  }
</style>